import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ProgramTemplateSearchResultWrapper = styled.div`
  margin: 19px 0px 39px;
  ${responsive.MOBILE`
      margin: 16px 0 0;
   `}
  .form-header {
    display: flex;
    align-items: center;
    background-color: ${COLORS.primary_light_blue2};
    padding: 10px 16px;
    justify-content: space-between;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }

  .MuiGrid2-root {
    width: 100%;
  }
  
  .cell-program-template-name {
    min-width: 285px;
  }
  .cell-line-of-business {
    min-width: 225px;
  }
  .cell-program-class {
    min-width: 200px;
  }
  .cell-solution-category {
    min-width: 225px;
  }
  .cell-status {
    min-width: 150px;
  }
  .cell-counry {
    min-width: 150px;
  }
  .nestedElement {
    margin-top: 10px;
  }
`;
